<template>
  <div>
    <h1 class="text-center">Resultater</h1>

    <div class="text-center mt-4">
      <p>Vi prøver så vidt muligt at opdatere oplysninger om resultater for HD/AD for vores afkom, samt resultater på diverse prøver.</p>

      <p>
        Da det til tider kan være lidt svært at følge med i resultaterne kan der smutte et...
        <br />Så hvis du har nogen bemærkninger er du velkommen til at kontakte os.
      </p>

      <p>Du finder det opdelt efter hunde i vores kennel. Der er også fra hunde vi ikke har mere, og prøverne er ikke opdelt - blot en liste med dem vi kan se.</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Resultater',
  computed: {
    ...mapState(['test', 'dogs'])
  }
};
</script>
